import { CSSProperties, HTMLAttributes, PointerEvent } from "react";

import { Dimension, sizes } from "../../design-tokens/dimensions";
import { Icon } from "../Icon";
import { Root } from "./styles";

type CloseButtonProps = {
  /**
   * Color of the icon.
   */
  color?: CSSProperties["backgroundColor"];
  /**
   * Height of the icon.
   */
  height?: Dimension;
  /**
   * The function to call when clicked.
   */
  onClick: (e: PointerEvent<HTMLButtonElement>) => void;
} & HTMLAttributes<HTMLButtonElement>;

export function CloseButton({ onClick, color, height = sizes.s16.rem, ...rest }: CloseButtonProps) {
  return (
    <Root
      variant="inline"
      data-testid={`${CloseButton.name}`}
      before={<Icon color={color} icon="close" height={height} />}
      onClick={onClick}
      {...rest}
    />
  );
}
